export default __webpack_public_path__ + "static/media/bizdevBlur.2b687b40.png";